// Four-connected fill: a closed outline contains the paint, including at canvas edges.
export function floodFill(image, x, y, color, tolerance = 24) {
  const {data, width, height} = image;
  x = Math.floor(x); y = Math.floor(y);
  if (x < 0 || y < 0 || x >= width || y >= height) return false;
  const start = (y * width + x) * 4;
  const target = Array.from(data.slice(start, start + 4));
  if (target.every((v, i) => v === color[i])) return false;
  const visited = new Uint8Array(width * height);
  const queue = new Int32Array(width * height);
  let head = 0, tail = 1;
  queue[0] = y * width + x;
  visited[queue[0]] = 1;
  while (head < tail) {
    const pixel = queue[head++], offset = pixel * 4;
    if (!target.every((v, i) => Math.abs(data[offset + i] - v) <= tolerance)) continue;
    data.set(color, offset);
    const px = pixel % width;
    for (const next of [px > 0 ? pixel - 1 : -1, px < width - 1 ? pixel + 1 : -1, pixel - width, pixel + width]) {
      if (next >= 0 && next < visited.length && !visited[next]) {
        visited[next] = 1;
        queue[tail++] = next;
      }
    }
  }
  return true;
}
export function shapeEnd(start, end, square) {
  if (!square) return end;
  const size = Math.max(Math.abs(end.x - start.x), Math.abs(end.y - start.y));
  return {x:start.x + (end.x < start.x ? -size : size), y:start.y + (end.y < start.y ? -size : size)};
}
